import { Observable, of, throwError } from 'rxjs';

import { catchError, switchMap, map, concatMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Application } from '../models';
import { Resource } from './resource';
import { ApiParams } from './api-params';
import { LoggerService } from '@content-platform/web-angular-shared-util-logging';
import { MOCK_APPLICATION_ACCESS_LIST, USE_MOCK_DATA_ON_ERROR } from './mock-data';

import {
  WebAngularSharedDataAccessFeatureFlagApisService 
} from '@content-platform/web-angular-shared-data-access-feature-flag-api';
@Injectable()
export class ApplicationResource extends Resource<Application> {

  constructor(http: HttpClient, logger: LoggerService, private apiParams: ApiParams,
    featureFlagSvc: WebAngularSharedDataAccessFeatureFlagApisService) {
    super(http, logger.instance('ApplicationResource'), featureFlagSvc);

    console.log('***Application resource initializeFeatureFlag');
    // configure the client
    // this.configureClient();

  }

  getUrl(featureFlag) {
    return this.apiParams.getUrl('applications', undefined, featureFlag);
  }

  /**
   * Only sends the api supported data for the application.
   *
   * @param application
   * @returns parsed application
   */
  protected transformRequest(application: Application): Application {
    const {
      id,
      features,
      name,
      deletedFeatures,
      lastModifiedBy,
      createdBy,
      hidden,
      url,
      imgUrl,
      imgUrlLrg,
      external,
      comingSoon,
      color,
      global,
    } = application;

    return {
      id,
      features,
      name,
      deletedFeatures,
      lastModifiedBy,
      createdBy,
      hidden,
      url,
      imgUrl,
      imgUrlLrg,
      external,
      comingSoon,
      color,
      global,
    };
  }

  get entityName(): string {
    return 'Application';
  }

  query(params?: HttpParams): Observable<Application[]> {
    return this.featureFlagSvc.getFlagAsync('use-new-gateway').pipe(
      catchError(() => {
        // does not exist
        return of(false);
      }),
      concatMap(flag => {
        return this.apiParams.getUrlAsync('applications', undefined, flag).pipe(
          switchMap((url) => this.http
            .get<Application[]>(url, { headers: this.getHeaders(), params: params })
            .pipe(
              map((data) => this.transformResponse(data)),
              catchError((error) =>
                USE_MOCK_DATA_ON_ERROR ? of(MOCK_APPLICATION_ACCESS_LIST) : throwError(error)
              )
            ))
        );
      })
    );
    
  }

  queryById(id): Observable<Application | Application[]> {
    return this.featureFlagSvc.getFlagAsync('use-new-gateway').pipe(
      catchError(() => {
        // does not exist
        return of(false);
      }),
      concatMap(flag => {
        return this.apiParams.getUrlAsync('applications', undefined, flag).pipe(
          switchMap((url) => this.http
            .get<Application | Application[]>(`${url}/${id}`, { headers: this.getHeaders()})
            .pipe(
              map((data) => data),
              catchError((error) =>
                USE_MOCK_DATA_ON_ERROR ? of(MOCK_APPLICATION_ACCESS_LIST) : throwError(error)
              )
            ))
        );
      })
    );
  }
}
